import { forwardRef, useRef, useImperativeHandle, useState, useEffect } from 'react';
import Image from 'next/image';

//* Style
import ImageStyle from './style';

const CustomImage = forwardRef(({ src, alt, className, width, height, priority = false, onLoad, ...props }, ref) => {
	const imgRef = useRef();

	//! State
	const [loaded, setLoaded] = useState(false);

	useImperativeHandle(ref, () => imgRef.current, []);

	//! Handle Image Load
	const onLoadCallback = () => {
		setLoaded(true);
	};

	useEffect(() => {
		if (typeof onLoad === 'function') {
			onLoad(loaded);
		}
	}, [loaded, onLoad]);

	return (
		<ImageStyle
			ref={imgRef}
			onClick={props.onClick}
			className={`imageCont ${className || ''}`}
			style={{
				width,
				height,
			}}
			{...props}
		>
			<Image
				fill
				draggable={false}
				priority={priority}
				placeholder='blur'
				alt={alt || 'image'}
				onLoad={onLoadCallback}
				quality={90}
				sizes='(max-width: 767px) 100%'
				src={src || '/images/default.jpeg'}
				loading={priority ? 'eager' : 'lazy'}
				blurDataURL={src || '/images/default.png'}
				style={{ opacity: loaded ? 1 : 0 }}
			/>
		</ImageStyle>
	);
});

CustomImage.displayName = 'CustomImage';

export default CustomImage;
